export default function Hero() {
  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20warm%20beige%20abstract%20geometric%20background%20with%20soft%20organic%20shapes%2C%20clean%20modern%20aesthetic%2C%20gentle%20texture%2C%20subtle%20gradient%2C%20editorial%20style%2C%20warm%20neutral%20tones%2C%20elegant%20minimal%20composition%20with%20soft%20shadows%20and%20airy%20negative%20space%2C%20sophisticated%20European%20design%20aesthetic&width=1600&height=900&seq=hero-bg-yoybuy-01&orientation=landscape"
          alt="YOYBUY Spreadsheet background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full px-8 md:px-12 lg:px-16 py-32 md:py-40">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20">
          <div className="lg:w-[60%]">
            <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] tracking-tight">
              YOYBUY Spreadsheet
              <br />
              Самый простой способ
              <br />
              покупать из Китая
            </h1>
          </div>

          <div className="lg:w-[40%] flex flex-col gap-6 pt-2">
            <p className="text-white/80 text-lg leading-relaxed max-w-md">
              Умная spreadsheet-система для покупок на Taobao, 1688 и Weidian без переплат
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-rocket-line text-lg"></i>
                Начать с YOYBUY Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/40 text-white font-semibold text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-shopping-cart-2-line text-lg"></i>
                buy it now
              </a>
            </div>
            <a
              href="#compare"
              className="inline-flex items-center gap-1 text-white/60 text-sm hover:text-white/90 transition-colors w-fit whitespace-nowrap"
            >
              <i className="ri-bar-chart-line"></i>
              Сравнить платформы
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}